module.exports = __webpack_public_path__ + "static/media/water-delivery-GIS-01.4f4791a8.jpg";